import { BRUSH_MODE } from '../../../annotations.interface';

export const DefaultConfiguration = {
  minRadius: 0.5,
  maxRadius: 100,
  radius: 25,
  mode: BRUSH_MODE.DRAW,
  color: '#ff324a',
} as const;
